import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CabanaDetail from "@/pages/CabanaDetail";

const TOAST_OPTIONS = {
  style: {
    background: "#FFFFFF",
    color: "#1A2421",
    border: "1px solid #E3DCD2",
    fontFamily: "Arial, Helvetica, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cabana/:id" element={<CabanaDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
